<template>
  <div>
    <div v-if="!dataLoaded">
      <div class="row">
        <div class="col-md-4">
          <div>
            <b-skeleton height="140px"></b-skeleton>
          </div>
          <div class="mt-3">
            <b-skeleton height="38px"></b-skeleton>
          </div>
        </div>
        <div class="col-md-4">
          <div>
            <b-skeleton height="140px"></b-skeleton>
          </div>
          <div class="mt-3">
            <b-skeleton height="38px"></b-skeleton>
          </div>
        </div>
        <div class="col-md-4">
          <div>
            <b-skeleton height="140px"></b-skeleton>
          </div>
          <div class="mt-3">
            <b-skeleton height="38px"></b-skeleton>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <b-skeleton-table
            :rows="5"
            :columns="4"
            :table-props="{ bordered: true, striped: true }"
          ></b-skeleton-table>
        </div>
      </div>
    </div>
    <div v-if="dataLoaded">
      <b-card title="انتقال وجه داخلی" sub-title="راهنما:">
        <b-card-text>
          <p>
            1- جهت استفاده از سرویس انتقال وجه داخلی ،ابتدا کد شپای مقصد را از
            شخص مورد نظر دریافت کنید.
          </p>
          <!-- <dt>Coffee</dt> -->
          <p>
            2- سپس برروی درگاه مرتبط با وبسایت خود کلیک کرده و عملیات انتقال وجه
            برای درگاه مقصد را انجام دهید.
          </p>
          <!-- <dt>Milk</dt> -->
          <p>
            3- پس از ثبت درخواست در صورت تائید از جانب شپا ،مبلغ درخواستی در
            لحظه جابجا خواهد شد و درگاه مقصد میتواند اقدام به برداشت از پنل شپای
            خود نماید.
          </p>
          <p>
            4- جهت دریافت وجه از درگاه دیگر فقط کافی است کد شپای خود را در
            اختیار شخض مورد نظر قرار دهید.
          </p>
        </b-card-text>
      </b-card>
      <b-card>
        <b-row>
          <div
            class="col-md-4"
            v-for="item in loadedlistGateway"
            v-bind:key="item.id"
          >
            <b-card no-body class="mt-2">
              <b-card-body>
                <b-row class="">
                  <b-col class="" md="8" sm="8" cols="8"
                    ><h6>{{ item.website_name }}</h6></b-col
                  >
                  <b-col
                    class="d-flex justify-content-end"
                    cols="4"
                    md="4"
                    sm="4"
                    >کد شپا : {{ item.id }}</b-col
                  >
                </b-row>

                <b-row class="pt-2">
                  <b-col class="" md="8" sm="8" cols="8">
                    مبلغ قابل انتقال:
                    {{
                      Number(
                        item.payment_priority == 1704
                          ? item.CanPaydBySharing
                          : item.CanPaydTomorow
                      ).toLocaleString()
                    }}
                    ريال</b-col
                  >
                  <b-col
                    class="d-flex justify-content-end"
                    md="4"
                    sm="4"
                    cols="4"
                  >
                    <a
                      style="cursor: pointer"
                      @click="ShowPopupRequestTransfer(item)"
                      :class="
                        item.CanPaydBySharing > 0
                          ? 'text-success'
                          : 'text-danger'
                      "
                      >انتقال وجه</a
                    >
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </div>
        </b-row>
      </b-card>
    </div>

    <b-modal id="modal-2" title="درخواست انتقال داخلی" v-model="show">
      <b-form-group label="کد پذیرنده مقصد:">
        <b-form-input v-model="destinationCode"></b-form-input>
      </b-form-group>
      <b-form-group label="مبلغ (ریال):">
        <NumberSeprator v-model="amount"></NumberSeprator>
      </b-form-group>
      <template #modal-footer>
        <div class="">
          <b-button
            size="md"
            class="float-right"
            @click="
              show = false;
              acceptorCode = null;
              destinationCode = null;
              amount = null;
            "
          >
            انصراف
          </b-button>
        </div>
        <div class="">
          <b-button
            variant="primary"
            size="md"
            class="float-right"
            @click="SendRequestInternalTransfer"
          >
            ثبت و پرداخت
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import TableShowData from "../../components/table";
import persianDate from "@/helpers/persianDate";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  GET_GATEWAY_LIST,
  SEND_INTERNAL_TRANSFER,
} from "@/core/services/store/internalTransfer.module";
import NumberSeprator from "@/components/numberSeprator";
import _ from "lodash";

export default {
  name: "internalTransfer",

  data() {
    return {
      show: false,
      acceptorCode: null,
      destinationCode: null,
      options: [],
      dataLoaded: false,
      amount: null,
    };
  },
  components: {
    "list-table": TableShowData,
    NumberSeprator,
  },
  computed: {
    loadedlistGateway() {
      return this.$store.getters.loadedlistGateway;
    },
  },
  created() {},
  mounted() {
    this.getGatewayList();
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "انتقال وجه داخلی",
      },
    ]);
  },
  methods: {
    SendRequestInternalTransfer() {
      if (
        this.acceptorCode != null &&
        this.destinationCode != null &&
        this.amount != null
      ) {
        this.$store
          .dispatch(SEND_INTERNAL_TRANSFER, {
            from_account: this.acceptorCode,
            to_account: this.destinationCode,
            amount: this.amount,
          })
          .then((data) => {
            if (data.success) {
              this.show = false;
              this.acceptorCode = null;
              this.destinationCode = null;
              this.amount = null;
              this.$makeToast(
                "success",
                "عملیات موفق",
                `درخواست انتقال شما به شماره پیگیری ${data.result} با موفقیت ثبت گردید.`,
                5000
              );
            }
          });
      } else {
        this.$makeToast(
          "danger",
          "خطا",
          "لطفا شماره پذیرنده مقصد را وارد کنید.",
          5000
        );
      }
    },
    getGatewayList() {
      this.dataLoaded = !this.dataLoaded;
      let obj = {};
      this.$store.dispatch(GET_GATEWAY_LIST).then((data) => {
        data.result.forEach((element) => {
          Object.assign(obj, {
            value: element.id,
            text: element.website_name + " " + element.id,
          });

          this.options.push(obj);
          obj = {};
        });
      });
    },
    ShowPopupRequestTransfer(item) {
      // if (item.CanPaydBySharing > 0 || item.ie == 1250 || item.ie == 345) {
      this.show = true;
      this.acceptorCode = item.id;
      // } else {
      //   this.$makeToast(
      //     "danger",
      //     "خطا",
      //     "به دلیل منفی بودن اعتبار حساب شما انتفال وجه مقدور نمی باشد.",
      //     5000
      //   );
      // }
    },
  },
};
</script>
<style scoped>
.guide p,
li {
  color: rgb(0, 0, 0);
  opacity: 0.6;
  font-size: 0.9rem;
  line-height: 50%;
}
</style>